import React from 'react';
import Icon from '../../../components/AppIcon';

const SettingsSidebar = ({ activeSection, onSectionChange }) => {
  const sections = [
    {
      id: 'profile',
      label: 'Profile',
      icon: 'User',
      description: 'Personal information and avatar'
    },
    {
      id: 'security',
      label: 'Security',
      icon: 'Shield',
      description: 'Password and authentication'
    },
    {
      id: 'billing',
      label: 'Billing',
      icon: 'CreditCard',
      description: 'Subscription and payment details'
    },
    {
      id: 'promocode',
      label: 'Promocode',
      icon: 'Gift',
      description: 'Redeem promocodes'
    }
  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden lg:block">
        <nav className="space-y-1">
          {sections.map((section) => (
            <button
              key={section.id}
              onClick={() => onSectionChange(section.id)}
              className={`w-full flex items-start space-x-3 px-4 py-3 text-left rounded-md transition-colors ${
                activeSection === section.id
                  ? 'bg-primary text-white' :'text-text-secondary hover:text-text-primary hover:bg-gray-50'
              }`}
            >
              <Icon 
                name={section.icon} 
                size={20} 
                className={activeSection === section.id ? 'text-white' : 'text-text-secondary'} 
              />
              <div>
                <div className={`text-sm font-medium ${
                  activeSection === section.id ? 'text-white' : 'text-text-primary'
                }`}>
                  {section.label}
                </div>
                <div className={`text-xs ${
                  activeSection === section.id ? 'text-white/80' : 'text-text-secondary'
                }`}>
                  {section.description}
                </div>
              </div>
            </button>
          ))}
        </nav>
      </div>

      {/* Mobile/Tablet Horizontal Tabs */}
      <div className="lg:hidden">
        <div className="border-b border-border">
          <nav className="flex space-x-1 overflow-x-auto">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => onSectionChange(section.id)}
                className={`flex items-center space-x-2 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                  activeSection === section.id
                    ? 'border-primary text-primary' :'border-transparent text-text-secondary hover:text-text-primary hover:border-gray-300'
                }`}
              >
                <Icon name={section.icon} size={18} />
                <span>{section.label}</span>
              </button>
            ))}
          </nav>
        </div>
      </div>
    </>
  );
};

export default SettingsSidebar;